import { render, staticRenderFns } from "./zsm.vue?vue&type=template&id=ff0d9646&scoped=true"
import script from "./zsm.vue?vue&type=script&lang=js"
export * from "./zsm.vue?vue&type=script&lang=js"
import style0 from "./zsm.vue?vue&type=style&index=0&id=ff0d9646&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0d9646",
  null
  
)

export default component.exports